import { Events } from './Events';
import { HtmlAttributes } from './HtmlAttributes';
import { ReactAttributes } from './ReactAttributes';
import { SchemaAttributes } from './SchemaAttributes';

const ariaAttributeRegex = /^aria-.*/;
const dataAttributeRegex = /^data-.*/;

function isValidAttribute(attribute) {
    if (HtmlAttributes.has(attribute)) {
        return true;
    }

    if (ReactAttributes.has(attribute)) {
        return true;
    }

    if (SchemaAttributes.has(attribute)) {
        return true;
    }

    if (Events.has(attribute)) {
        return true;
    }

    if (dataAttributeRegex.test(attribute)) {
        return true;
    }

    if (ariaAttributeRegex.test(attribute)) {
        return true;
    }

    return false;
}

export function filterToValidAttributes(attributes) {
    const validAttributes = Object.keys(attributes).filter(isValidAttribute);

    const filteredAttributes = {};

    validAttributes.forEach(attribute => {
        filteredAttributes[attribute] = attributes[attribute];
    });

    return filteredAttributes;
}
